// ====================== LENIS ======================

const lenis = new Lenis({
    smoothWheel: true,
    smoothTouch: false,
    normalizeWheel: true,
    ignore: (el) => el.classList.contains("scroll-section"),
});

lenis.on("scroll", ScrollTrigger.update);

gsap.ticker.add((time) => {
    lenis.raf(time * 700);
});
gsap.ticker.lagSmoothing(0);

// ====================== LENIS ======================

// ====================== HEADER EFFECT ======================

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header');
  let lastScrollY = window.scrollY;

  window.addEventListener('scroll', () => {
    const currentY = window.scrollY;

    // AT TOP
    if (currentY <= 0) {
      header.classList.add('is-at-top');
      header.classList.remove('is-scrolled', 'is-scroll-up');
    }
    // SCROLLING DOWN
    else if (currentY > lastScrollY && currentY > 20) {
      header.classList.add('is-scrolled');
      header.classList.remove('is-scroll-up', 'is-at-top');
    }
    // SCROLLING UP
    else if (currentY < lastScrollY) {
      header.classList.add('is-scroll-up');
      header.classList.remove('is-scrolled', 'is-at-top');
    }

    lastScrollY = currentY;
  }, { passive: true });
});



// ====================== HEADER EFFECT ======================

// ================== CART BUTTON MOBILE =====================

document.addEventListener('DOMContentLoaded', () => {

  const getCartBtn = () =>
    document.querySelector('.header .head_main .head_right .acc_list li.bag-item .header__icon--cart');

  const triggerClick = (e) => {
    const trigger = e.target.closest('.mob-story-btn-li');
    if (!trigger) return;

    const cartBtn = getCartBtn();
    if (!cartBtn) return;

    e.preventDefault();
    e.stopPropagation();

    // iOS-safe async click
    requestAnimationFrame(() => {
      cartBtn.dispatchEvent(new PointerEvent('pointerdown', { bubbles: true }));
      cartBtn.click();
    });
  };

  /* iOS-approved events */
  ['touchstart', 'pointerdown', 'click'].forEach(evt => {
    document.addEventListener(evt, triggerClick, { passive: false });
  });

});

// ================== CART BUTTON MOBILE =====================



document.addEventListener("DOMContentLoaded",()=>{
const target = document.querySelector("product-recommendations");

if (target) {
  const observer = new MutationObserver((mutations,obs) => {
    for (const mutation of mutations) {
        obs.disconnect();
       
      if (mutation.type === "childList") {
            document.querySelectorAll('.productSwiper').forEach((slider) => {
            new Swiper(slider, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 0,
                allowTouchMove: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    dynamicBullets: true,
                },
                navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
                },
            });
        });
        break;
      }
    }
  });

  observer.observe(target, {
    childList: true, // watch children add/remove
  });
}
const collectionProducts = document.querySelector(".active-facets.active-facets-desktop");
if (collectionProducts) {
  const observer = new MutationObserver((mutations,obs) => {
    for (const mutation of mutations) {
            document.querySelectorAll('.productSwiper').forEach((slider) => {
            new Swiper(slider, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 0,
                allowTouchMove: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    dynamicBullets: true,
                },
                navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
                },
            });
        });
        break;
    }
  });

  observer.observe(collectionProducts, {
    childList: true, // watch children add/remove,
    subtree: true,
  });
}


document.querySelectorAll('.productSwiper').forEach((slider) => {
      new Swiper(slider, {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 0,
  allowTouchMove: true, // ✅ enable touch
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    dynamicBullets: true,
  },
  navigation: {
    nextEl: slider.querySelector('.swiper-button-next'),
    prevEl: slider.querySelector('.swiper-button-prev'),
  },
});

    });

    // for product-rec

});


// =============== hamburger =================

const toggleBtn = document.querySelector('.toggle-btn-d');
const mobileMenu = document.querySelector('.head_ham_container');
const menuOverlay = document.querySelector('.menu-overlay');

function closeMenu() {
  toggleBtn.classList.remove('active');
  mobileMenu.classList.remove('active-cont');
  menuOverlay?.classList.remove('active');

  document.body.style.overflow = '';
}

function menuOpen() {
  toggleBtn.classList.toggle('active');
  mobileMenu.classList.toggle('active-cont');
  menuOverlay?.classList.toggle('active');

  // Lock scroll
  if (mobileMenu.classList.contains('active-cont')) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = '';
  }
}

// Open / Toggle
toggleBtn.addEventListener('click', menuOpen);

// Close when clicking overlay
menuOverlay?.addEventListener('click', closeMenu);

// Close on ESC
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    closeMenu();
  }
});


// =============== hamburger =================




